<template>
    <div>
        <div class="container">
            <!-- Modal -->
            <div class="modal fade" id="order-details-modal" role="dialog">
                <div class="modal-dialog">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <button
                                type="button"
                                data-dismiss="modal"
                                class="close text-white text-light">
                                <span title="Close">
                                    X
                                </span>
                            </button>
                        </div>
                        <div class="modal-body order-modal">
                            <div class="receipt-wrap" v-if="selectedOrder">
                                <div class="row pl pr">
                                    <div class="col-xs-12 col-md-6">
                                        <div class="user-field">
                                            <p class="field-title">Order ID</p>
                                            <p class="field-value">#{{ selectedOrder.order_number }}</p>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-md-6">
                                        <div class="user-field">
                                            <p class="field-title">Email Address</p>
                                            <p class="field-value">{{ selectedOrder.email }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row pl pr">
                                    <div class="col-xs-12 col-md-6">
                                        <div class="user-field">
                                            <p class="field-title">Billing Address</p>
                                            <p class="field-value">
                                                {{ selectedOrder.payload.billing_address.address1 }},
                                                {{ selectedOrder.payload.billing_address.city }},
                                                {{ selectedOrder.payload.billing_address.zip }},
                                                {{ selectedOrder.payload.billing_address.province }},
                                                {{ selectedOrder.payload.billing_address.country_code }}
                                            </p>
                                        </div>
                                        <div class="user-field">
                                            <p class="field-title">Phone</p>
                                            <p class="field-value">
                                                {{ selectedOrder.payload.billing_address.phone ? selectedOrder.payload.billing_address.phone : '—' }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-md-6">
                                        <div class="user-field">
                                            <p class="field-title">Shipping Address</p>
                                            <p class="field-value">
                                                {{ selectedOrder.payload.shipping_address.address1 }},
                                                {{ selectedOrder.payload.shipping_address.city }},
                                                {{ selectedOrder.payload.shipping_address.zip }},
                                                {{ selectedOrder.payload.shipping_address.province }},
                                                {{ selectedOrder.payload.shipping_address.country_code }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-md-6">
                                        <div class="user-field">
                                            <p class="field-title">Status</p>
                                            <p class="field-value">
                                                {{ selectedOrder.status }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12">
                                        <div id="no-more-tables" class="table-responsive">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th class="pl">Product</th>
                                                        <th>Price</th>
                                                        <th>Qty</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td v-if="isMobile" data-title="Product">
                                                            BLD {{ selectedOrder.bld_number }}
                                                        </td>
                                                        <td v-else data-title="Product">
                                                            BLD Product: {{ selectedOrder.bld_number }}
                                                        </td>
                                                        <td class="pl-0" data-title="Price">$ {{ selectedOrder.payload.total_line_items_price }}</td>
                                                        <td class="pl-0" data-title="Qty">1</td>
                                                        <td class="pl-0" data-title="Total">$ {{ selectedOrder.payload.total_line_items_price }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3">Item Subtotal</td>
                                                        <td class="pl-0">$ {{ selectedOrder.payload.total_line_items_price }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3">Total Discount</td>
                                                        <td class="pl-0">
                                                            $ {{ selectedOrder.payload.total_discounts }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3">Shipping &amp; Handling</td>
                                                        <td class="pl-0">
                                                            $ {{ selectedOrder.payload.shipping_lines[0].price }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3">Tax</td>
                                                        <td class="pl-0">
                                                            $ {{ selectedOrder.tax }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="total-price" colspan="3">Order Total</td>
                                                        <td class="total-price pl-0">$ {{ selectedOrder.payload.total_price }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="!['Shipped', 'Cancelled'].includes(selectedOrder.status)"
                                    class="row pl pr change-order"
                                >
                                    <div class="col-xs-12">
                                        <p>
                                            Within 2 hours of purchase, you can
                                            <a href="https://support.nzxt.com/hc/en-us/requests/new?ticket_form_id=360003161653&utm_source=useraccount&utm_medium=useraccount&utm_campaign=changepart" target="_blank">
                                                change or cancel
                                            </a>
                                            your order.<br>
                                            Beyond this window, any changes may incur additional fees or delay your order.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="track-order" class="modal fade" role="dialog">
                <div class="modal-dialog">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <button
                                type="button"
                                data-dismiss="modal"
                                class="close text-white text-light">
                                <span title="Close">
                                    X
                                </span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <user-tracking-order v-if="selectedOrder && selectedOrder.access_hash" :access-hash="selectedOrder.access_hash" :in-page="false" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel-body">
            <div class="user-pc-builds">
                <div class="builds-tables">
                    <div class="table-responsive">
                        <div id="no-more-tables">
                            <template v-if="orders.length && !loadingOrders">
                                <div v-for="order in orders" :key="order.id" class="order-wrapper clearfix text-white" >
                                    <div class="col-md-5 col-xs-12 order-number">
                                        #{{ order.order_number }} {{ order.created_at | humanizeDate }}
                                    </div>
                                    <div class="col-md-7 col-xs-12 text-right">
                                        <button
                                            v-if="order.access_hash"
                                            @click="showTrackingModal(order)"
                                            class="btn btn-green hover-white">
                                            TRACK ORDER
                                        </button>
                                        <button
                                            @click="showOrderModal(order)"
                                            class="btn btn-green hover-white">
                                            VIEW ORDER
                                        </button>
                                    </div>
                                </div>
                            </template>
                            <template v-if="!orders.length && !loadingOrders">
                                <div class="text-center">
                                    <h4 class="text-white m-b-md">
                                        You have not made a purchase from LETSBLD.com yet!
                                    </h4>
                                    <router-link class="btn btn-sm btn-round btn-green" to="/bld">
                                        GO TO BLD
                                        <i class="fa fa-long-arrow-right" />
                                    </router-link>
                                </div>
                            </template>
                            <template v-if="loadingOrders">
                                <div style="text-align:center">
                                    <span class="fa fa-spin fa-spinner" />
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import userTrackingOrder from "./user-tracking-order";
import { isMobile } from "@u/helpers.js";

export default {
    name: "OrderHistory",
    components: {
        userTrackingOrder
    },
    data() {
        return {
            loadingOrders: true,
            // Orders of the logged in user
            orders: [],
            // An order that was selected by clicking the 'view order' button
            selectedOrder: null,
            isMobile: false
        }
    },
    created() {
        this.getOrders();
        this.isMobile = isMobile();
    },
    mounted() {
        $("#track-order").on('hidden.bs.modal', (e) => {
            this.selectedOrder = null;
        });
    },
    methods: {
        //  Gets the orders of the logged in user
        getOrders() {
            axios({
                url: "/users/0/orders",
                method: "GET"
            }).then(orders => {
                orders.data = orders.data.map(order => {
                    order.payload = JSON.parse(order.payload);
                    return order;
                })
                this.orders = orders.data.reverse();
                this.loadingOrders = false;
            }).catch(error => {
                console.log(error);
                this.loadingOrders = false;
            })
        },
        showTrackingModal(order) {
            this.selectedOrder = order;
            this.$nextTick(() => {
                $("#track-order").modal("show");
            })
        },
        showOrderModal(order) {
            this.selectedOrder = order;
            this.$nextTick(() => {
                $("#order-details-modal").modal("show");
                $("#order-details-modal").on('hidden.bs.modal', (e) => {
                    this.selectedOrder = null;
                });
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@s/_asset-mixers.scss';

@media only screen and (max-device-width : 480px) {
    .pl-0 {
        padding-left: 0px !important;
    }
}

.pl {
    padding-left: 30px;

    @media only screen and (max-device-width : 480px) {
        font-size: 12px;
        padding: 5px 20px !important;
    }
}

.pr {
    padding-right: 30px;
}

.order-modal {
    padding: 0;
}

.table {
    margin: 0;
}

.user-field .field-value {
    font-size: 18px;
    line-height: 1;
    color: #fff;

    @media only screen and (max-device-width : 480px) {
        font-size: 15px;
    }
}

.change-order {
    p {
        color: $white;
        margin: 17px 0 29px;
    }

    a {
        text-decoration: underline;

        &:hover {
            text-decoration: none;
        }
    }
}

td.total-price {
    background-color: $purple;
    color: #fff;
}

table td {
    font-size: 14px;
    color: #fff;
    padding: 5px 30px !important;
    border-top: none !important;

    @media only screen and (max-device-width : 480px) {
        font-size: 12px;
        padding: 5px 20px !important;
    }
}

table tr th {
    color: $orchid;
    border-bottom: none;
}

table tr::before,
table tr th::after {
    content: '';
    display: block;
    width: 85%;
    height: 1px;
    background: $purple;

    position: absolute;
    left: 46px;

    @media only screen and (max-device-width : 480px) {
        width: 80%;
        left: 34px;
    }
}

table tr th::after {
    background: #fff;
    top: 32px;
}

table tr:nth-child(1) {
    &::before {
        background: transparent;
    }
}

table th {
    font-size: 14px;
    color: $purple;
    padding-left: 30px !important;

    @media only screen and (max-device-width : 480px) {
        font-size: 12px;
        padding-left: 0 !important;
    }
}

.blue-btn {
    background-color: $purple;
    text-transform: uppercase;
    display: inline-block;
    width: 100%;
    text-align: center;
    color: #000;
    letter-spacing: 2px;
    border: none;
    border-radius: 25px;
    padding: 10px 10px;
    transition: all 0.4s ease;
    font-size: 12px;
    line-height: 20px;
    padding: 5px 0;
    width: 158px;
}

.order-wrapper {
    border-bottom: 1px solid #fff;
    padding: 10px 0;

    .btn {
        padding: 10px 35px;

        @media screen and (max-width: 1200px) {
            padding: 10px 15px;
        }
    }

}

@media screen and (max-width: 767px) {
    .table-responsive {
        margin-bottom: 0;
        border: none;
    }
}
</style>
